import { point3D } from "./interfaces";

const distanceSquared = function(p1: point3D, p2: point3D) {

    return ((p1.x - p2.x)*(p1.x - p2.x)) + ((p1.y - p2.y)*(p1.y - p2.y)) + ((p1.z - p2.z)*(p1.z - p2.z));
}

export default distanceSquared